module.exports = {
  siteMetadata: {
    title: 'Savasa Impressores',
    description: 'Savasa Impressores produz rótulos para cervejas, detergente, água, sucos, produtos de limpeza e higiene com soluções inovadoras e alto valor agregado.',
    siteUrl: 'https://www.savasa.com.br',
    author: 'CloudDog',
    keywords:
      'Savasa impressores, rótulo, soluções de rótulos, gráfica de rótulo'
  },
  pathPrefix: '/',
  plugins: [
    'gatsby-plugin-eslint',
    'gatsby-transformer-sharp',
    'gatsby-plugin-sharp',
    'gatsby-plugin-catch-links',
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-sass',
    'gatsby-plugin-sitemap',
    'gatsby-plugin-remove-serviceworker',
    {
      resolve: 'gatsby-plugin-layout',
      options: {
        component: require.resolve('./src/layouts/index.js')
      }
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'pages',
        // eslint-disable-next-line node/no-path-concat
        path: `${__dirname}/src/pages`
      }
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'images',
        // eslint-disable-next-line node/no-path-concat
        path: `${__dirname}/src/images`
      }
    },
    {
      resolve: 'gatsby-plugin-nprogress',
      options: {
        // Setting a color is optional.
        color: '#e66827',
        // Disable the loading spinner.
        showSpinner: false
      }
    },
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        name: 'Savasa Impressores',
        short_name: 'Savasa Impressores',
        description: 'Savasa Impressores',
        start_url: '/',
        background_color: '#fff',
        theme_color: '#f38132',
        display: 'standalone',
        icon: 'src/images/logo-favicon.png'
      }
    },
    {
      resolve: 'gatsby-plugin-google-analytics',
      options: {
        trackingId: 'UA-124859249-1',
        // Puts tracking script in the head instead of the body
        head: true,
        // Setting this parameter is optional
        anonymize: false,
        // Setting this parameter is also optional
        respectDNT: false
      }
    },
    {
      resolve: 'gatsby-plugin-s3',
      options: {
        bucketName: process.env.DEPLOYMENT_BUCKET || 'fake-bucket',
        region: process.env.AWS_REGION,
        acl: 'bucket-owner-full-control',
        enableS3StaticWebsiteHosting: false,
        removeNoneexistentObjects: false,
        params: {
          '**/**.html': {
            CacheControl: 'public, max-age=0, must-revalidate'
          },
          'manifest.webmanifest': {
            CacheControl: 'public, max-age=0, must-revalidate'
          },
          'sitemap.xml': {
            CacheControl: 'public, max-age=3360000, must-revalidate'
          },
          '**/**.json': {
            CacheControl: 'public, max-age=0, must-revalidate'
          },
          'static/**': {
            CacheControl: 'public, max-age=31536000, immutable'
          },
          '**/**/!(sw).js': {
            CacheControl: 'public, max-age=31536000, immutable'
          },
          '**/**.css': {
            CacheControl: 'public, max-age=31536000, immutable'
          },
          'sw.js': {
            CacheControl: 'public, max-age=0, must-revalidate'
          }
        }
      }
    }
  ]
}
